import { render, staticRenderFns } from "./referrals.vue?vue&type=template&id=131ca823&scoped=true&lang=pug&"
import script from "./referrals.vue?vue&type=script&lang=js&"
export * from "./referrals.vue?vue&type=script&lang=js&"
import style0 from "./referrals.vue?vue&type=style&index=0&id=131ca823&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ca823",
  null
  
)

export default component.exports